// extracted by mini-css-extract-plugin
export default {"pageTitle":"SupportPage_pageTitle__Qx+wu","supportMessenger":"SupportPage_supportMessenger__h8+oC"};